import React from'react';import{IconButton}from'@fluentui/react/lib/Button';var iconProps={iconName:'Cancel'};var iconBtnStyle={position:'absolute',top:0,right:0,zIndex:1};export default function CloseButton(_ref){var onClick=_ref.onClick,_ref$fontSize=_ref.fontSize,fontSize=_ref$fontSize===undefined?12:_ref$fontSize;return React.createElement(IconButton,{style:iconBtnStyle,iconProps:Object.assign({},iconProps,{style:{fontSize:fontSize}}),onClick:onClick});}


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseButton.js
// module id = 837
// module chunks = 29